<template>
  <div class="p-4">
    <UsuariosCongregacion title="Gestión de Usuarios" />
  </div>
</template>

<script setup>
import UsuariosCongregacion from '@/components/UsuariosCongregacion.vue'
</script>
